// Module
var code = "<template> <div dt-grid-container=\"full-width: true\"> <div dt-grid-row> <h1>Problemer</h1> <require from=\"./problem-list-component\"></require> <problem-list-component inhibit-query-without-reference-id.bind=\"false\"> </problem-list-component> </div> </div> </template> ";
// Exports
export default code;